import React, { useEffect } from 'react';
import './Clients.css';

export default function Clients() {
  useEffect(() => {
    document.title = 'Clients';
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <div className="page-banner" style={{ backgroundImage: 'url(/clients_banner.webp)' }}>
        <h1 className="page-banner-title" id="clients-heading">
          Our Clients
        </h1>
      </div>
      <section className="clients-main-content" aria-labelledby="clients-intro-heading">
        <p className="clients-intro-text" id="clients-intro-heading">
          Inalab is proud to partner with leading federal agencies and organizations to deliver mission-critical 
          <br />
          solutions and measurable results.
        </p>
        <div className="partners-image-container">
          <img 
            src="/client_new.png" 
            alt="Various client logos including U.S. Federal Government agencies and organizations" 
            className="partners-img"
          />
        </div>
      </section>
    </>
  );
} 